import React from 'react';
import './rightMenu.css';
import RightMenuButton from './RightMenuButton';
import RightMenuDetails from './RightMenuDetails';
import { connect } from 'react-redux';

class RightMenu extends React.Component {
    constructor(props) {
        super(props);

        this.setTopPosition = this.setTopPosition.bind(this)
    }

    setTopPosition() {
        let topPosition = '';
        let rightMenuButtonsContainer = document.getElementById('rightMenuButtonsContainer');
        let tabsList = document.getElementById('tabs').children[0];

        if (this.props.activeTable === 'SQUARES') {
            topPosition = document.getElementsByClassName('single-grid-th')[0].clientHeight + 60 + 'px';
            tabsList.style.top = topPosition;
        }
        else {
            topPosition = document.getElementById('rightMenuButtonsContainer').style.top;
        }
        /* eslint-disable no-unused-expressions */
        rightMenuButtonsContainer ? rightMenuButtonsContainer.style.top = topPosition : '';
    }

    componentDidMount() {
        this.setTopPosition();
        window.addEventListener('resize', this.setTopPosition)

    }

    render() {
        return (
            <div id="rightMenu">
                <div id="rightMenuButtonsContainer">
                    <RightMenuButton src={"/akademia/image/ico_konto.svg"} text={"Eksport"} />
                    <RightMenuButton src={"/akademia/image/ico_pomoc.svg"} text={"Pomoc"} />
                </div>
                <RightMenuDetails />
            </div>
        )
    }
}

export default connect(
    state => ({
        activeTable: state.activeTable
    })
)(RightMenu);



// WEBPACK FOOTER //
// ./src/RightMenu.js